import { SignFrame } from '../sign/enums/sign-frame';
import { SignLocationType } from './sign-location-type';

export class SignStockEditRequest {
  signId: number;

  locationType: SignLocationType;
  rack: number;
  shelf: string;
  compartment: number;

  frame: SignFrame;

  amountIncrease: number;
}
